<template>
    <div>
        <div id="wrapper">
            <sidebar />
            <div id="content-wrapper" class="d-flex flex-column">
                <navigation navbarClass="navbar-dark" profileSettingsRoute="/admin/profile/settings" profileInfoRoute="/admin/profile/info"/>
                <div id="content">
                    <div class="container-fluid">
                        <router-view></router-view>
                    </div>
                </div>
                <app-footer footerClass="bg-gray-900 text-white"></app-footer>
            </div>
        </div>
        <a class="scroll-to-top rounded">
            <i class="fas fa-angle-up"></i>
        </a>
        <div class="modal fade" id="logoutModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{{$t('READY_TO_LEAVE')}}?</h5>
                        <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">{{$t('LOGOUT_CONFIRMATION_MESSAGE')}}</div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" type="button" data-dismiss="modal">{{$t('CANCEL')}}</button>
                        <a class="btn btn-primary" href="login.html">{{$t('LOGOUT')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>import Sidebar from './partials/Sidebar'
    import Footer from './../../layouts/partials/Footer'
    import Navigation from './../../layouts/partials/Navigation'
    export default {
        components: {
            'sidebar': Sidebar,
            'app-footer': Footer,
            'navigation': Navigation
        },
        data() {
            return {

            }
        },
        mounted: function () {

        }
    }</script>
<style lang="scss" scoped>
    
</style>